import { InvitationStatusEnum } from '@application/enums/event-status-enum';
/** Backend sends C# enum names, e.g. "InProgress". */
const nameToEnum = {
    Pending: InvitationStatusEnum.Pending,
    InProgress: InvitationStatusEnum.InProgress,
    Registered: InvitationStatusEnum.Registered,
    Invited: InvitationStatusEnum.Invited,
    Expired: InvitationStatusEnum.Expired,
    Declined: InvitationStatusEnum.Declined,
    NotComing: InvitationStatusEnum.NotComing
};
export function parseFamilyFestInvitationStatus(raw) {
    if (raw == null || String(raw).trim() === '')
        return null;
    const key = String(raw).trim();
    const direct = nameToEnum[key];
    if (direct !== undefined)
        return direct;
    const normalized = key.length > 0 ? key.charAt(0).toUpperCase() + key.slice(1).replace(/\s+/g, '') : key;
    return nameToEnum[normalized] ?? null;
}
/** Excel export — same labels as invitation chips where applicable. */
export function formatFamilyFestInvitationStatusLabel(raw, t) {
    const e = parseFamilyFestInvitationStatus(raw);
    if (e == null)
        return (raw ?? '').trim();
    switch (e) {
        case InvitationStatusEnum.Invited:
            return t('events.eventDetails.invitationsTab.invited');
        case InvitationStatusEnum.InProgress:
            return t('events.eventDetails.invitationsTab.inProgress');
        case InvitationStatusEnum.Registered:
            return t('events.eventDetails.invitationsTab.registered');
        case InvitationStatusEnum.NotComing:
            return t('events.eventDetails.invitationsTab.notComing');
        case InvitationStatusEnum.Expired:
            return t('events.eventDetails.invitationsTab.expired');
        case InvitationStatusEnum.Declined:
            return t('events.eventDetails.invitationsTab.declined');
        case InvitationStatusEnum.Pending:
        default:
            return t('events.pending');
    }
}
